<template>
  <vx-card no-shadow title="Firm Feed Visibility">
    <a-form>
        <a-radio-group class="flex flex-col space-y-4">
          <a-radio :value="1">
            Everywhere
          </a-radio>
          <a-radio  :value="2">
            Everywhere but matters page
          </a-radio>
          <a-radio :value="3">
            Nowhere
          </a-radio>
        </a-radio-group>

      <div class="flex items-center mt-10">
        <a-button type="primary" size="large" style="border-radius: 3px !important;">
          Save
        </a-button>
        <div class="pl-2">or</div>
        <a-button type="link">
          Cancel
        </a-button>
      </div>
    </a-form>

  </vx-card>
</template>

<script>
    export default {
        name: "FirmFeed"
    }
</script>

<style scoped>

</style>
